import React from 'react';
import PropTypes from 'prop-types';
import './Inventory.scss';


const Inventory = ({ language }) => {
  return (
    <div className="inventory-catalog-container">
      <div className="container">
        <zr-vehicles-inventory-widget
          lang={language.toLowerCase() ?? 'en'}
        ></zr-vehicles-inventory-widget>
      </div>
    </div>
  );
};

export default Inventory;

Inventory.propTypes = {
  language: PropTypes.string.isRequired,
};
